import moment from 'moment';

export const URL_DATE_FORMATS = ['MM/DD/YYYY', moment.ISO_8601];
